export const password = (value, vm) => {
  if (vm.password === '' || vm.password2 === '') return true
  return vm.password === vm.password2
}
